export default __webpack_public_path__ + "static/22_30-b5d2bd27edb7fa5aaab2086e8e0ab6fa.png";